<script lang="ts">
    import { STATUS } from "@/constants/statuses";
    import ReviewsAverageRatingStars from "@apps/reviews/components/ReviewsAverageRatingStars/ReviewsAverageRatingStars.svelte";
    import {
        PRODUCT_REVIEW_FORM_ID,
        QUESTION_FORM_ID,
    } from "@apps/reviews/constants";
    import { createEventDispatcher } from "svelte";

    import Button from "@components/Buttons/Button.svelte";
    import T from "@components/T.svelte";

    import ReviewsListInfoEntity from "../../../entities/ReviewsListInfoEntity";
    import ReviewsListHeaderFrame from "./ReviewsListHeaderFrame.svelte";
    import ReviewsProgressBar from "./ReviewsProgressBar.svelte";

    export let ratesInfo: ReviewsListInfoEntity["ratesInfo"];
    export let averageRating: number;
    export let reviewsCount: number;
    export let reviewsListInfoStatus: STATUS;
    export let isReviewsAppEnabled: boolean;
    export let isQuestionsAppEnabled: boolean;
    export let addReviewButtonEnabled: boolean;
    export let addQuestionButtonEnabled: boolean;

    const dispatch = createEventDispatcher();

    const handleAddReview = () => {
        dispatch("addReview");
    };
    const handleAddQuestion = () => {
        dispatch("addQuestion");
    };
</script>

<ReviewsListHeaderFrame
    on:addQuestion
    on:addReview
    hideRatingHeader={reviewsListInfoStatus === STATUS.READY &&
        reviewsCount === 0}
>
    <svelte:fragment slot="avg">
        {#if isReviewsAppEnabled}
            {averageRating.toFixed(1)}
        {/if}
    </svelte:fragment>

    <svelte:fragment slot="rating">
        {#if isReviewsAppEnabled}
            <ReviewsAverageRatingStars rating={averageRating} />
        {/if}
    </svelte:fragment>

    <svelte:fragment slot="count">
        {#if isReviewsAppEnabled}
            <span class="gw-rv-listing-layout__rate-count">
                <T
                    namespace="reviews.ReviewsProductPageWidget"
                    translationKey="based_on"
                    translationOptions={{ count: reviewsCount }}
                />
            </span>
        {/if}
    </svelte:fragment>

    <svelte:fragment slot="progress-bars">
        {#if isReviewsAppEnabled}
            <ul
                class="gw-list-reset-default-styles gw-rv-listing-layout__progress-bars"
            >
                {#each [...ratesInfo].reverse() as review}
                    <ReviewsProgressBar
                        allReviewsCount={reviewsCount}
                        reviewCount={review.countReview}
                        rate={review.rating}
                    />
                {/each}
            </ul>
        {/if}
    </svelte:fragment>

    <svelte:fragment slot="actions">
        {#if isQuestionsAppEnabled && addQuestionButtonEnabled}
            <Button
                variant="opacityOnHover"
                size="large"
                on:click={handleAddQuestion}
                aria-controls={QUESTION_FORM_ID}
                aria-haspopup="dialog"
            >
                <span>
                    <T
                        namespace="reviews.critical.ReviewsProductPageWidget"
                        translationKey="ask_a_question"
                    />
                </span>
            </Button>
        {/if}

        {#if isReviewsAppEnabled && addReviewButtonEnabled}
            <Button
                id="write-review-btn"
                variant="opacityOnHover"
                size="large"
                on:click={handleAddReview}
                aria-controls={PRODUCT_REVIEW_FORM_ID}
                aria-haspopup="dialog"
            >
                <T
                    namespace="reviews.critical.ReviewsProductPageWidget"
                    translationKey="write_a_review"
                />
            </Button>
        {/if}
    </svelte:fragment>
</ReviewsListHeaderFrame>

<style>
    .gw-rv-listing-layout__progress-bars {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
</style>
